import React, { useState } from "react";
import { wsRequest } from "./wsClient.js";
import Footer from "./Footer.jsx";
import { useNavigate } from "./Navigation.jsx";

// Reached via the link in the "Other" broadcast email content box
// (see getOrCreateUnsubscribeToken on the backend) —
// /unsubscribe?token=... Deliberately requires a real button click
// rather than acting the moment the page loads — an email-security
// scanner or link-prefetcher visiting the link automatically (a
// known, real risk with GET-based one-click actions) would otherwise
// unsubscribe someone who never actually clicked anything themselves.
export default function UnsubscribePage() {
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get("token");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);

  const confirm = async () => {
    setError(null);
    setBusy(true);
    try {
      await wsRequest("email.unsubscribe", { token });
      setDone(true);
    } catch (err) {
      setError(err.message || "Could not reach backend.");
    }
    setBusy(false);
  };

  return (
    <div style={{ color: "var(--text-primary)", minHeight: "100vh" }}>
      <div style={{ maxWidth: 420, margin: "0 auto", padding: "40px 20px" }}>
        <h2>Unsubscribe</h2>

        {!token ? (
          <p style={{ opacity: 0.85, lineHeight: 1.6 }}>
            This link is missing its unsubscribe token — please use the link from the email directly, rather than
            navigating here on its own.
          </p>
        ) : done ? (
          <>
            {/* BOTH KINDS OF LINK land here since 1.394.0 — an account's, and
                a reminder subscriber's who has no account — and the page
                deliberately does not say which it was, as before. So it
                says what is true of both. */}
            <p style={{ opacity: 0.85, lineHeight: 1.6 }}>
              You've been unsubscribed. Competition reminders you had signed up for will not be sent, and if you
              have an account, site update emails are off too — you can turn those back on anytime from your
              account settings.
            </p>
            <button onClick={() => navigate("/")}>Back to site</button>
          </>
        ) : (
          <>
            <p style={{ opacity: 0.85, lineHeight: 1.6, marginTop: 0 }}>
              Click below to stop competition reminders and occasional site update emails. This won't affect
              receipts, payout notices, or other emails tied to your own account activity.
            </p>
            <button disabled={busy} onClick={confirm}>
              {busy ? "…" : "Unsubscribe"}
            </button>
            {error && <div style={{ color: "var(--accent-red)", fontSize: 13, marginTop: 8 }}>{error}</div>}
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
